var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 18.2L15.725 12H11.725L12.45 6.325L7.82497 13H11.3L10.55 18.2ZM8.99997 15H5.89997C5.49997 15 5.20414 14.8208 5.01247 14.4625C4.8208 14.1042 4.84164 13.7583 5.07497 13.425L12.55 2.675C12.7166 2.44166 12.9333 2.27916 13.2 2.1875C13.4666 2.09583 13.7416 2.1 14.025 2.2C14.3083 2.3 14.5166 2.475 14.65 2.725C14.7833 2.975 14.8333 3.24166 14.8 3.525L14 10H17.875C18.3083 10 18.6125 10.1917 18.7875 10.575C18.9625 10.9583 18.9083 11.3167 18.625 11.65L10.4 21.5C10.2166 21.7167 9.99164 21.8583 9.72497 21.925C9.4583 21.9917 9.19997 21.9667 8.94997 21.85C8.69997 21.7333 8.50414 21.5542 8.36247 21.3125C8.2208 21.0708 8.16664 20.8083 8.19997 20.525L8.99997 15Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.805d880ed79fd9fbbb763acd2c85e7d4.svg";
export { ForwardRef as ReactComponent };